import { render, staticRenderFns } from "./PlatonModalForm.vue?vue&type=template&id=666a1804&"
import script from "./PlatonModalForm.vue?vue&type=script&lang=js&"
export * from "./PlatonModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports